import { AssociationBody } from '../../store/Ticket';
import { apiService } from '../APIService';

const API_SERVER_URL = process.env.REACT_APP_API_SERVER_URL;

export const associateTicketsByAsset = (body: AssociationBody) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/ticket-relations/asset`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: body
  });
};

export const removeRefByAssetId = (assetId: string, ticketId: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/ticket-relations/ticket/${ticketId}/asset/${assetId}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const associateTicketsByPA = (body: AssociationBody) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/ticket-relations/provisional-asset`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: body
  });
};

export const removeRefByPAId = (paId: string, ticketId: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/ticket-relations/ticket/${ticketId}/provisional-asset/${paId}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const associateTicketsByRPMAcct = (body: AssociationBody) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/ticket-relations/rpm-account`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: body
  });
};

export const createContractReferences = (ticketId: string) => {
  return apiService.callExternalApi<{ assetCount: number; rpmAccountCount: number }>({
    url: `${API_SERVER_URL}/ticket-relations/ticket/${ticketId}/contract-references`,
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const removeRefByRpmAcctId = (rpmAccountId: string, ticketId: string) => {
  return apiService.callExternalApi<void>({
    url: `${API_SERVER_URL}/ticket-relations/ticket/${ticketId}/rpm-account/${rpmAccountId}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
